import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BulletPlot from "./BulletPlot";
import PropTypes from 'prop-types';

am4core.useTheme(am4themes_animated);

class DumbbellPlot extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		dataset: PropTypes.array.isRequired,
	};
	componentDidUpdate(prevProps) {
		if (prevProps.dataset !== this.props.dataset) {
			this.componentDidMount(this.props.dataset);
		}
	}
	componentDidMount() {
		const { id, dataset } = this.props;

		var chart = am4core.create(id, am4charts.XYChart);
		chart.data = dataset
		// chart.data = [
		// 	{
		// 		name: "SMP 1 Eduprime",
		// 		start: 1.0,
		// 		middle: 1.8,
		// 		end: 2.5,
		// 	},
		// 	{
		// 		name: "SMP 2 Eduprime",
		// 		start: 1.2,
		// 		middle: 2.0,
		// 		end: 2.6,
		// 	},
		// 	{
		// 		name: "SMP 3 Eduprime",
		// 		start: 1.5,
		// 		middle: 2.1,
		// 		end: 2.8,
		// 	},
		// 	{
		// 		name: "SMP 4 Eduprime",
		// 		start: 0.9,
		// 		middle: 1.7,
		// 		end: 2.4,
		// 	},
		// 	{
		// 		name: "SMP 5 Eduprime",
		// 		start: 1.0,
		// 		middle: 1.8,
		// 		end: 2.5,
		// 	},
		// 	{
		// 		name: "SMP 6 Eduprime",
		// 		start: 1.1,
		// 		middle: 1.9,
		// 		end: 2.6,
		// 	},
		// 	{
		// 		name: "SMP 7 Eduprime",
		// 		start: 1.0,
		// 		middle: 1.8,
		// 		end: 2.5,
		// 	},
		// 	{
		// 		name: "SMP 8 Eduprime",
		// 		start: 1.2,
		// 		middle: 2.0,
		// 		end: 2.6,
		// 	},
		// 	{
		// 		name: "SMP 9 Eduprime",
		// 		start: 1.5,
		// 		middle: 2.1,
		// 		end: 2.8,
		// 	},
		// 	{
		// 		name: "SMP 10 Eduprime",
		// 		start: 1.0,
		// 		middle: 1.8,
		// 		end: 2.5,
		// 	},
		// 	{
		// 		name: "SMP 11 Eduprime",
		// 		start: 1.2,
		// 		middle: 2.0,
		// 		end: 2.6,
		// 	},
		// ];

		var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "name";
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.ticks.template.disabled = true;
		categoryAxis.renderer.axisFills.template.disabled = true;
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.renderer.inversed = true;
		categoryAxis.renderer.grid.template.location = 0.5;

		var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
		valueAxis.tooltip.disabled = true;
		valueAxis.renderer.ticks.template.disabled = true;
		valueAxis.renderer.axisFills.template.disabled = true;
		valueAxis.renderer.opposite = true;
		valueAxis.renderer.labels.template.adapter.add("text", function (text) {
			return Number(text).toFixed(1);
		});

		var series = chart.series.push(new am4charts.ColumnSeries());
		series.strokeWidth = 1.5;
		series.stroke = am4core.color("black");
		series.dataFields.categoryY = "name";
		series.dataFields.openValueX = "start";
		series.dataFields.valueX = "end";
		series.tooltipText =
			"Start: {openValueX.value}\nEnd: {valueX.value}\nMiddle: {middle}";

		series.sequencedInterpolation = true;
		series.fillOpacity = 0;
		series.strokeOpacity = 1;
		series.columns.template.height = 0.01;
		series.tooltip.pointerOrientation = "vertical";

		/* START DATA */
		var startBullet = series.bullets.push(new am4charts.Bullet());
		startBullet.locationX = 1;
		var startImage = startBullet.createChild(am4core.Image);
		startImage.href = BulletPlot.rectangle();
		startImage.width = 20;
		startImage.height = 20;
		startImage.horizontalCenter = "middle";
		startImage.verticalCenter = "middle";

		// MIDDLE DATA
		var bullet = series.bullets.push(new am4charts.Bullet());
		bullet.locationX = 0; // Initialize locationX
		bullet.adapter.add("locationX", function (locationX, target) {
			var dataItem = target.dataItem;
			if (dataItem) {
				var open = dataItem.openValueX;
				var close = dataItem.valueX;
				var middle = dataItem.dataContext.middle;

				// Kalkulasi mencari lokasi middle data, Boleh di improve lagi
				locationX = (middle - close) / (open - close);
			}
			return locationX;
		});

		var middleImage = bullet.createChild(am4core.Image);
		middleImage.href = BulletPlot.rectangle({ width: 6, color: "black" });
		middleImage.width = 6;
		middleImage.height = 20;
		middleImage.horizontalCenter = "middle";
		middleImage.verticalCenter = "middle";

		/* END DATA */
		var endBullet = series.bullets.push(new am4charts.Bullet());
		var endImage = endBullet.createChild(am4core.Image);
		endImage.href = BulletPlot.rectangle({ color: "#055659" });
		endImage.width = 20;
		endImage.height = 20;
		endImage.horizontalCenter = "middle";
		endImage.verticalCenter = "middle";

		chart.cursor = new am4charts.XYCursor();
		chart.cursor.behavior = "zoomY";

		// Uncomment ini uutk menampilkan scrollable axis x dan y
		// chart.scrollbarX = new am4core.Scrollbar();
		// chart.scrollbarY = new am4core.Scrollbar();
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	render() {
		const { id } = this.props;
		return <div id={id} style={{ width: "100%", height: "1000px" }}></div>;
	}
}

export default DumbbellPlot;
